module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "y-popconfirm"
  }, [_c('y-tooltips', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "theme": "white y-popconfirm",
      "trigger": _vm.trigger,
      "placement": _vm.placement
    },
    domProps: {
      "value": (_vm.show)
    },
    on: {
      "input": function($event) {
        _vm.show = $event
      }
    }
  }, [_c('template', {
    slot: "slot"
  }, [_vm._t("slot")], 2), _vm._v(" "), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "y-tooltips-title"
  }, [_c('y-svg', {
    staticClass: "icon",
    attrs: {
      "type": "help",
      "width": 20
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), (_vm.$slots.btn) ? _c('div', {
    staticClass: "y-tooltips-content"
  }, [_vm._t("btn")], 2) : _c('div', {
    staticClass: "y-tooltips-content"
  }, [(_vm.backBtn.show) ? _c('y-button', {
    attrs: {
      "type": "ghost"
    },
    domProps: {
      "textContent": _vm._s(_vm.backBtn.text)
    },
    nativeOn: {
      "click": function($event) {
        _vm.onBack($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.okBtn.show) ? _c('y-button', {
    domProps: {
      "textContent": _vm._s(_vm.okBtn.text)
    },
    nativeOn: {
      "click": function($event) {
        _vm.onOk($event)
      }
    }
  }) : _vm._e()], 1)])], 2), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-144f4052!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/popconfirm/popconfirm.vue
// module id = 451
// module chunks = 27